import { render, staticRenderFns } from "./EvaluateDetail.vue?vue&type=template&id=72352859&scoped=true"
import script from "./EvaluateDetail.vue?vue&type=script&lang=js"
export * from "./EvaluateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72352859",
  null
  
)

export default component.exports